






































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportExportItem from "../models/MetRiportExportItem";
import moneyFormat from "@/filters/money-format";

interface Data {
    store: MetRiportStore;
    loading: boolean;
}

interface Methods {
    updateItem(item: MetRiportExportItem): void;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        IconButton
    },

    async beforeMount() {
        this.loading = true;
        await store.loadItemTypes();
        this.loading = false;
    },

    data() {
        return {
            store,
            loading: false,
        };
    },

    methods: {
        updateItem(item: MetRiportExportItem): void {
            item.inEdit = true;
            store.updateMetRiportExportItem(item).then(r => eventBus.$emit('refreshMetRiportExportItems'));
        }
    },

    computed: {
        url() {
            return `met-riport/export/${this.store.metRiportExportHead.id}/items/search`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    filterable: false,
                    sortable: false,
                },
                {
                    field: "metRiportItemName",
                    title: "Tétel neve",
                },
                {
                    field: "metType",
                    title: "Metis típúsa",
                    cell: "metType",
                    multiselect: true,
                    multiselectField: "selectedMetisTypes",
                    multiselectOptions: store.itemTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                {
                    field: "metisCode",
                    title: "Metis kód",
                },
                {
                    field: "notPcCode",
                    title: "DMS Kód nélkül?",
                    cell: "notPcCode",
                },
                {
                    field: "dmsCode",
                    title: "DMS kód",
                    type: ColumnType.Right
                },
                {
                    field: "calcWithDefault",
                    title: "Alapért. értékkel számol?",
                    cell: "calcWithDefault",
                },
                {
                    field: "dmsValue",
                    title: "Érték",
                    cell: "dmsValue",
                    type: ColumnType.Right
                }
            ];
        },
    }
});
